export default {
    cancelOrderMap: {
        0: "私はそれをしたくありません。",
        1: "商品を置き忘れた",
        2: "重複注文",
        3: "受信に失敗しました",
        4: "その他の理由",
    },
    "电商批发商场": "電子商取引卸売市場",
    "请输入完整的支付密码!" : "完全な支払いパスワードを入力してください！",
    "用户未发表评论": "ユーザーはコメントしていません",
    "订单": "注文",
    "下单成功，等待付款": "注文は正常に行われ、支払いを待っています",
    "下单成功，付款成功": "注文が正常に行われ、支払いが完了しました",
    "已发货，正在运输中": "出荷済み、輸送中",
    "订单已取消，原因:手动发起取消订单": "注文はキャンセルされました。 理由: 注文を手動でキャンセルします。",
    "订单已取消，原因:超时自动取消订单": "注文はキャンセルされました。 理由: 注文はタイムアウト時に自動的にキャンセルされます。",
    "商家已确认，已进入备货状态": "商人が確認され、在庫状態に入りました。",
    "系统发货成功": "システム配信成功",
    "订单已签收": "ご注文承りました",
    "发起退款申请": "払い戻しリクエストを開始する",
    "退款成功": "払い戻しが成功しました",
    "退款失败": "払い戻しに失敗しました",
    "订单退款成功": "注文の払い戻しが成功しました",
    "订单退款失败": "注文の払い戻しに失敗しました",
    "系统默认好评": "システムはデフォルトで好意的なレビューを表示します",
    "请输入关键字搜索": "キーワードを入力して検索してください",
    "猜你喜欢": "あなたはそれが好きだと思います",
    "订单已完成": "注文が完了しました",
    "热销推荐": "売れ筋のおすすめ",
    "头像选择": "アバターの選択",
    "修改头像": "変更する",
    "获取验证码": "確認コードを取得する",
    "请输入验证码": "確認コードを入力してください",
    "验证码": "確認コード",
    "发送": "送信",
    "已发送，请注意查收": "送信しました。 注意してください",
    subOrder: "注文を送信",
    "mailboxCheck": "正しいメールアドレスを入力してください",
    "switchLang": "表示するには別の言語に切り替えてください",
    "myCart": "私のショッピングカート",
    "notQua": "資格条件を満たしていません。",
    "noSmaller": "適用された金額は以下にすることはできません",
    "nomax": "お申し込み上限額を超えることはできません",
    "evaluationUploading": "まだ写真をアップロードしています。 後でもう一度やり直してください",
    "evaluateInput": "写真で振り返る",
    "moneyOrderStatus": "注文の状況",
    "coinBlock": "通貨協定",
    "dealing": "処理中",
    "dealSuccess": "成功",
    "dealFail": "失敗",
    "payCertificate": "支払証明書",
    "handleFee": "サービス料",
    "highOpinion": "良いレビュー",
    "mediumOpinion": "中程度のレビュー",
    "lowOpinion": "悪いレビュー",
    "hasImage": "写真付き",
    "rechargeMethod": "充電モード",
    "scanAndDown": "QRコードをスキャン アプリをダウンロード",
    "receivedAddress": "受取先",
    "ActualLedger": "実際の領収書",
    "view": "意見",
    "withdrawNum": "出金枚数",
    "rechargeNum": "充電量",
    "date": "日にち",
    "walletHistory": "ウォレット履歴",
    "accountBalance": "勘定残高",
    "accountReview": "口座[アカウント]状況",
    "rated": "審査",
    "receiver": "レシーバー",
    "orderStatus": "スターテス",
    "orderTime": "時間",
    "tax": "課税",
    "discount": "割引",
    "productInfo": "商品情報",
    "paramError": "パラメータエラー",
    "orderInfo": "注文情報",
    "rebuy": "もう1つ注文",
    "pleaseCorrectAddress": "正しい現金引き出しアドレスを入力してください",
    "pleaseInputCorrectNumber": "0 より大きい数値を入力してください",
    "vcodePass": "検証に合格しました！",
    "vcodeFail": "認証に失敗しました。もう一度やり直してください",
    "uploading": "アップロード中...",
    "uploadSuccess": "アップロード成功",
    "uploadError": "アップロードに失敗しました。 もう一度お試しください",
    "registerSuccess": "登録成功",
    "pleaseSetMobileNumber": "電話番号を設定してください",
    "unSelectedProduct": "製品を選択していません",
    "loginSuccess": "ログイン成功",
    "pleaseSetAreaCode": "国名と市外局番を入力して検索",
    "login": "ログイン",
    "register": "登録",
    "logout": "出口",
    "noData": "何もデータが見つかりませんでした",
    "search": "検索",
    "historySearch": "履歴検索",
    "empty": "空",
    "home": "ホームページ",
    "favorableRate": "良いレビュー率",
    "classification": "カテゴリー",
    "searchTips": "ソース検索/製品/サプライヤー/注文",
    "dailyNewArrival": "毎日の新製品リスト",
    "more": "もっと",
    "recommend": "おすすめ",
    "recommendedProducts": "おすすめ商品",
    "recommendedStore": "おすすめ店",
    "buyNow": "今すぐ購入",
    "addCart": "ショッピングカートに入れる",
    "complex": "統合",
    "price": "価格",
    "retailPrice": "小売価格",
    "originPrice": "元値",
    "service": "顧客サービス",
    "collect": "お気に入り",
    "sold": "販売量",
    "pageviews": "閲覧量",
    "quantity": "量",
    "freight": "貨物",
    "shipping": "運送",
    "ship": "ボート",
    "buyTips": "ご注文後24時間以内に発送。 以下の注文は物流管理下にあり、発送が遅れる場合があります。 物流情報に注意を払うか、カスタマーサービスに連絡してください。",
    "totalPrice": "合計金額",
    "addCartMessage": "ショッピングカートに追加されました",
    "addCartMessageFaild": "商品はすでにショッピング カートに入っています。",
    "myAccount": "私のqアカウント",
    "buyHistory": "購入記録",
    "wishlist": "お気に入りの商品",
    "trackOrder": "注文",
    "account": "アカウント：",
    "sellerZone": "商圏",
    "beSeller": "商人になる",
    "sellerPanelLogin": "加盟店ログイン",
    "footTip": "© Copyright {name} Ltd 2024",
    "footTips": "{name} Limited は、信用ブローカー (713206) として Financial Conduct Authority によって認可および規制されており、貸し手である Home Retail Group CardServices Limited を {name} Financial Services として独占的に扱っています。 {name} Financial Services は、Financial Conduct Authority によってクレジットを提供することを承認および規制されています (716148)。 ホーム リテール GroupCard Services Limited は、英国 (04007072) Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom で登録されています。 MK9 2NW.",
    "item": "記事",
    "checkout": "注文する",
    "productDescription": "製品説明",
    "userEvaluation": "ユーザーレビュー",
    "AllProducts": "すべての製品",
    "followers": "従う",
    "sales": "販売量",
    "visitStore": "ストアにアクセス",
    "authentic": "100%本物",
    "dayReturns7": "7日返品",
    "shippingDiscounts": "貨物割引",
    "safePayment": "安全なお支払い",
    "followed": "フォローした",
    "dashboard": "インストルメント・パネル",
    "myOrder": "私の注文",
    "setUp": "設定",
    "successTips": "成功",
    "copySuccess": "レプリケーションが成功しました",
    "balance": "残高(USDT)",
    "sort": "タイプ",
    "commodity": "製品",
    "browse": "販売量",
    "recharge": "リチャージ",
    "commodityCollection": "製品コレクション",
    "withdraw": "現金引き出し",
    "defaultAddress": "デフォルトの住所",
    "addNewAddress": "新しいアドレスを追加",
    "withdrawRecord": "出金記録",
    "serialNumber": "注文番号。",
    "time": "時間",
    "amount": "額",
    "processing": "処理中",
    "fail": "失敗",
    "blockchainNetwork": "ブロックチェーン ネットワーク",
    "records": "記録",
    "withdrawAddress": "現金引き出しアドレス",
    "withdrawInputTips": "出金先住所を入力してください",
    "copy": "レプリケーション",
    "enterTips": "入ってください",
    "actualAccount": "実際のアカウント",
    "handlingFee": "サービス料",
    "confirm": "領収書の確認",
    "previous": "一つ前の手順",
    "pleaseEnterAddress": "住所を入力してください",
    "pleaseEnterQuantity": "数量を入力してください",
    "withdrawSuccess": "注文は正常に送信されました",
    "saveQr": "QRコードを保存",
    "pleaseEnterAmount": "チャージ金額を入力してください",
    "expectedArrival": "到着予定",
    "currentRate": "現在の為替レート",
    "uploadTips": "支払証明（支払詳細のスクリーンショットをアップロード）",
    "clickUpload": "クリックしてアップロード",
    "uploadPhoto": "写真をアップロードしてください",
    "rechargeSuccessful": "リチャージ成功",
    "rechargeTips": "再充電プロンプト: 「実際の送金金額を正直に入力してください。そうしないと、システムが承認に失敗し、再充電の進行に影響を与える可能性があります。",
    "rechargeRecord": "充電記録",
    "all": "全て",
    "pending": "支払われる",
    "cancelled": "キャンセル",
    "delivered": "出荷されます",
    "confirmed": "確認済み",
    "receipt": "受信する",
    "harvested": "受け取った",
    "comment": "レビュー予定",
    "refund": "返金/アフターセールス",
    "cancelOrder": "注文をキャンセルする",
    "cancelReason": "キャンセル理由",
    "cancelOrderTitle": "注文キャンセル理由を選択してください",
    "returnOrderTitle": "返品理由を選択してください",
    "refundInstructions": "払い戻しの手順",
    "returnDetailTips": "商品のレビューをお願いします",
    "cancel": "注文をキャンセルする",
    "cancelOrder1": "商品が届かない",
    "cancelOrder2": "好きじゃない、欲しくない",
    "cancelOrder3": "売り手が間違った商品を発送した",
    "cancelOrder4": "偽ブランド",
    "cancelOrder5": "出荷が少ない、出荷を逃した",
    "cancelOrder6": "受け取った商品が破損している",
    "cancelOrder7": "品質に問題がある",
    "cancelOrder8": "販売者と返金の交渉をする",
    "cancelOrder9": "その他の理由",
    "cancelOrderSuccess": "注文は正常にキャンセルされました",
    "returnOrderSuccess": "正常に送信",
    "orderName": "名前",
    "orderEmail": "Eメール",
    "orderAddress": "住所",
    "orderNation": "国",
    "orderState": "スターテス",
    "orderCity": "街",
    "orderPostCode": "郵便番号",
    "orderAmount": "量",
    "orderPrefix": "合計注文",
    "orderFee": "税金",
    "orderSpecification": "仕様",
    "orderCommodity": "製品",
    "orderQuantity": "量",
    "orderUnitprice": "単価",
    "orderFreight": "貨物",
    "orderTax": "税",
    "orderTotal": "合計",
    "PaymentOrder": "支払指図書",
    "Evaluate": "レビュー",
    "CancelOrder": "注文をキャンセルする",
    "RemindShip": "出荷の通知",
    "Refund": "返金",
    "Submitareview": "レビューを送信する",
    "Information": "情報",
    "wrongPassword": "パスワードエラーが 3 回以上発生しました。 明日もう一度お試しください。",
    "Operate": "手術",
    "Item": "アイテム",
    "From": "から",
    "hint": "チップ",
    "CheckDetails": "詳細を見る",
    "Payment": "支払い",
    "Cancel": "キャンセル",
    "refundSuccessfully": "払い戻しが成功しました",
    "pendingPayment": "支払われる",
    "pay": "支払い",
    "LoginPassword": "ログインパスワード",
    "sure": "もちろん",
    "shippingAddress": "受信アドレス",
    "pleaseAddShippingAddress": "先に配送先住所を追加してください",
    "transactionPassword": "取引パスワード",
    "markDefaultAddress": "デフォルトの配送先住所としてマーク",
    "edit": "によって編集",
    "delete": "消去",
    "Opt": "選択する",
    "piece": "個",
    "orderDetails": "注文詳細",
    "shopCollection": "ストアをお気に入りに追加",
    "addAddress": "新しいアドレスを追加",
    "signUp": "登録",
    "loginTips": "すでにアカウントをお持ちですか？",
    "loginIn": "ログイン",
    "mobile": "電話番号",
    '购物车还没有商品': "ショッピングカートに商品がありません",
    '去购物': "ショッピングに行く",
    "modifyAddress": "住所変更",
    "desc": "デフォルトのアドレスとして設定",
    "keep": "維持",
    "onlineService": "オンラインサービス",
    "send": "送信",
    "EsShop": "オンラインストア",
    "desc3": "取引パスワードを入力",
    "desc4": "取引パスワードを入力してください",
    "desc6": "取引パスワードをもう一度入力してください",
    "setUpPayPaw": "取引パスワードの設定",
    "setSuccess": "セットアップ成功",
    "confirmPayPaw": "取引パスワードの確認",
    "paymentSuccessful": "お支払い完了",
    "paymentPending": "支払い保留中",
    "paymentPendingDesc": "お支払いが処理中です。しばらくしてから注文状況をご確認ください",
    "desc5": "配送先住所が間違っていませんか？ コンタクト",
    "customeService": "オンラインカスタマーサービス",
    "BackHome": "ホームページに戻ります",
    "Checkorder": "表示の順序",
    "ForgotPassword": "パスワードをお忘れですか？",
    "signIn": "ログイン",
    "noAccount": "口座番号がない？",
    "pleaseEnterAccount": "口座番号を入力してください",
    "pleaseEnterPassword": "パスワードを入力してください",
    "password": "パスワード",
    "mobilePhone": "電話番号",
    "pleaseEnterPhoneNumer": "電話番号を設定してください",
    "setPassword": "パスワードを設定してください",
    "noDataFound": "何もデータが見つかりませんでした",
    "searchCountry": "国名と市外局番を入力して検索",
    "pleaseEnterEmail": "メールボックスを設定してください",
    "invitationCode": "招待コード",
    "plaeseEnterInvitaionCode": "招待コードを設定してください",
    "pleaseSetLoginPassword": "ログインパスワードを設定してください",
    "selectDeliveryAddress": "配送先住所を選択",
    "totalOf": "合計",
    "items": "アイテム",
    "orderSummary": "注文の概要",
    "paymentMethod": "支払方法",
    "Balance": "バランス",
    "payPal": "ペイパル",
    "notOpen": "この支払い方法は、お住まいの地域ではまだ利用できません",
    "mastercard": "マスターカード",
    "additional": "追加",
    "handlingfee": "サービス料が必要",
    "goodsNumber": "製品の数量",
    "deliveryFee": "貨物",
    "totalNum": "合計",
    "new": "新しい",
    "oldPassword": "以前のパスワード",
    "pleaseEnterOldPassword": "古いパスワードを入力してください",
    "newPassword": "新しいパスワード",
    "plaseeEnterNewPassword": "新しいパスワードを入力してください",
    "confirmPassword": "パスワードを認証する",
    "plaseeENterConfirmPassword": "確認パスワードを入力してください",
    "twoPawword": "2 つのパスワードが同じではありません",
    "rechargeAddress": "リチャージアドレス",
    "plaseEnterRechargeAddress": "リチャージアドレスを入力してください",
    "userCenter": "パーソナルセンター",
    "merchantSettled": "商人のエントリ",
    "upNew": "新製品リスト",
    "balanceNot": "バランスが足りない。 充電してください。",
    "NoProductSelected": "製品はまだ選択されていません",
    "ShippingAddressNotSet": "配送先住所が設定されていません",
    "consigneeName": "受取人の名前",
    "email": "Eメール：",
    "areaCode": "国際市外局番",
    "phoneNumber": "電話番号",
    "nation": "国",
    "state": "州/州/州",
    "city": "街",
    "postCode": "郵便番号",
    "address": "詳細住所",
    "addAddressOrModifyAddress": "新しい住所を追加する/住所を変更する",
    "setAsTheDefaultAddress": "デフォルトのアドレスとして設定",
    "proceed": "続く",
    "btnSure": "確認",
    "pleaseInput": "入ってください",
    "allProduct": "すべての製品",
    "myCommodityCollection": "お気に入りの商品",
    "myFollowedShops": "店舗をフォローする",
    "mySold": "売却",
    "myPageviews": "閲覧量",
    "myPraiseRate": "良いレビュー率",
    "myUnfollow": "フォローをやめる",
    "inputNum": "数字",
    "inpuEmailErro": "正しいメールアドレスを入力してください",
    "goodsShip": "出荷",
    "goodsShipTips": "商品はご注文後24時間以内に発送いたします。 下記のご注文は物流管理が行き届いている場合、ご注文が遅れる場合がございます。 注文のロジスティクス情報に注意するか、カスタマーサービスに連絡してください。",
    "goodsFreight": "貨物",
    "goodsFreeShipping": "無料",
    "goodsFreightTips1": "1. 越境商品の運賃構成：運賃＝発送手数料＋長距離運賃＋配送料",
    "goodsFreightTips2": "2. 郵便料金の条件が満たされていない場合、貨物は実際の条件に従って請求されます。",
    "goodsFreightTips3": "3. 最終解釈権はプラットフォームに帰属します。",
    "pleaseValidPostCode": "4桁以上で入力してください",
    "pleaseValidEmail": "正しいメールアドレスを入力してください",
    "pleaseValidPhone": "正しい電話番号を入力してください",
    "productAvailable": "この商品は削除されました",
    "validatorMaxNumber": "金額が上限を超えています",
    "validatorRequire": "必須項目を null にすることはできません",
    "validatorPhone": "正しい電話番号を入力してください",
    "validatorEmail": "正しいメール形式を入力してください",
    "validatorPassword": "パスワードは 6 ～ 12 桁の数字または文字で構成されています(特殊文字が含まれています)",
    "validatorSixNumber": "純粋な 6 桁を入力してください",
    "validatorFourMoreNumber": "4 ～ 32 桁の数字または文字の組み合わせを入力してください",
    "validatorIpRule": "不正な IP 形式",
    "validatorChineseAndEnglish": "中国語と英語のみ、入力範囲: 8 ～ 64 文字",
    "collectionSuccess": "お気に入りに追加しました",
    "followedSuccess": "フォロー成功",
    "cancelSuccess": "キャンセルしました",
    "evaluateOrder": "写真で振り返る",
    recommendclass:"おすすめカテゴリー",
    "滑动验证": "スライド認証",
    "evaluateOrderPlaceholder": "製品を確認してください",
    "operationSuccess": "操作は成功しました",
    "confirmReceiveGoods": "商品の受領確認",
    "evaluateOrderSuccess": "レビュー成功",
    "yesterday": "昨日",
    "notLogin": "まだログインしていません。",
    "delAllHistoryRecord": "すべての履歴レコードを削除してもよろしいですか?",
    "or": "また",
    "tipsRemindsText": "出荷が通知された後、マーチャントは通知を受け取ります",
    "tipsRemindsCount": "1 回だけ思い出させることができます。",
    "tipsRemindsMerchant": "マーチャントに通知する",
    "tipsRemindsSuccess": "リマインダーが成功しました",
    "noCartTips": "ショッピングバッグは空です。 ショッピングを開始します。",
    "defaultRate": "システムはデフォルトで好意的なレビューを表示します",
    "prevPage": "前のページ",
    "nextPage": "次のページ",
    "returnApply": "払い戻しのリクエスト",
    "returnReason": "返金理由",
    "returnAmount": "返品金額",
    "returnRemark": "返品手順",
    order: {
        cancel: "注文をキャンセルする",
        payment: "今払う",
        remind: "出荷の通知",
        return: "商品返金のお願い",
        evaluate: "今すぐレビュー",
        logistics: "ロジスティクスを見る",
        noRefund: "未払い",
        refunding: "払い戻し中",
        refundSuccess: "払い戻しが成功しました",
        refundFail: "払い戻しに失敗しました",
        confirm: "領収書の確認",
    },
    "remindTitle": "出荷の通知",
    "remindContent": "出荷のリマインダーが送信されると、マーチャントはリマインダーを受け取ります。 1 回だけ思い出させることができます。",
    "remindSuccess": "リマインダーが成功しました",
    "remindRepeat": "この順番を思い出しました。",
    "noComments": "現在レビューはありません",
    "storeSeach": "このストアで商品を探す",
    "storeSeachTips1": "あなたのために見つけました",
    "storeSeachTips2": "関連店舗が見つかりました",
    "storeSeachTips3": "家",
    "creditTit": "クレジットサービス",
    "getCoupons": "より多くのクーポンを入手",
    "yourEmail": "あなたのメールアドレス",
    "subscription": "サブスクリプション",
    "paymethods": "支払方法",
    "footdec": "{name}Shop グローバル サイトのユーザーは、世界 {num} か国から来ており、決済には {coin} を使用しています。 {coin} は、国際手数料や待ち時間なしで、世界中で即時かつ低コストの取引を可能にするボーダレス取引です。",
    "custService": "顧客サービス",
    "helpLine": "オンラインカスタマーサービス",
    "contactUs": "お問い合わせ",
    "partner": "協力業者",
    "客户端下载":
        "クライアント ダウンロード",
    "提现方式": "出金方法",
    "buyRules": "バイヤーのルール",
    "sellerRules": "売り手の方針",
    "returnsAndEx": "返品と交換",
    "servicePolicy": "サービスポリシー",
    "returnPolicy": "返品規則",
    "user_Center": "ユーザーセンター",
    "userReg": "ユーザー登録",
    "orderTrack": "注文クエリ",
    "purchageHistory": "購入履歴",
    "myPurse": "私の財布",
    "aboutUs": "私たちに関しては",
    "Recruitment": "有能な人材を待つ",
    "news": "ニュース情報",
    "stateMent": "現代の奴隷制に関する声明",
    "binance": "バイナンス",
    "huobi": "フォビ",
    "okx": "わかりました",
    "metaMask": "メタマスク",
    "homeBannertips1": "商人になる",
    "homeBannertips2": "合計手数料",
    "homeBannertips3": "最大。",
    "homeBannerbtn": "今すぐ参加",
    "homeDownloadtips1": "越境EC卸モール",
    "homeDownloadtips2": "ブランド特典",
    "homeDownloadtips3": "ノンストップ割引",
    "homeDownloadtips4": "アンドロイド ダウンロード",
    "homeDownloadtips5": "アップルのダウンロード",
    "homeDownloadtips6": "QRコードをスキャンしてアプリをダウンロード",
    "homeIconTips1": "100%本物",
    "homeIconTips2": "7日返品",
    "homeIconTips3": "貨物割引",
    "homeIconTips4": "安全なお支払い",
    "headerSearchTips": "キーワードを入力して検索してください",
    "collAccount": "貸出形態",
    "mine": "私の。",
    "creditText1": "お金を借りる時の悩みをスタートアップローンで解決",
    "creditText2": "スタートアップローンおよび資本回転サービスの提供",
    "creditWorry": "安心のローン",
    "creditQuota": "柔軟な制限",
    "creditQuotaINFO": "100,000 ～ 30,000,000 の柔軟な制限と制限なし、最長 1 年間の融資期間。",
    "quickLoan": "クイックローン",
    "creditReview": "審査は最短1時間で通過、審査を通過すれば即日融資。",
    "safe": "安全で安心",
    "safeInfo": "これは実際には個人的な問題であるため、住宅ローン、預金、コールバックはありません。",
    "about": "私たちに関しては",
    "aboutText1": "私たちは、「お客様第一」の経営理念に基づき、お客様の資本回転の問題を解決することを使命として、融資金融サービスに取り組んでいます。 同社は創業以来、多くのクライアントの資本回転の問題を解決するお手伝いをしてきました。",
    "aboutText2": "限度額: 100,000-30,000,000、低金利の柔軟な返済方法、初期費用なし、オンライン ローン、確認のための電話なし、機密情報、および即日融資。",
    "contactUs1": "レベルメイトからお金を借りたくない場合は、お問い合わせください。",
    "committed": "起業家ローンサービスにコミット",
    "financial": "経済的な懸念に対処する",
    "partnersTit": "パートナー オンライン レンディング プラットフォーム",
    "application": "ローン申し込み",
    "applicant": "申請者",
    "actualName": "本名",
    "yourName": "名前を入力してください",
    "term": "貸出期間",
    "applicationAmount": "請求金額",
    "rates": "ローン金利",
    "loanMethod": "貸出形態",
    "accountB": "勘定残高",
    "countryOf": "国籍",
    "myloan": "私のローン",
    "applyLoan": "ローンを申し込む",
    "loaned": "貸与",
    "interest": "経過利息",
    "esRepayment": "返済予定額",
    "loanHistory": "貸出記録",
    "applicantDate": "出願日",
    "repayment": "返済",
    "cycle": "返済サイクル",
    "fixedRate": "固定金利",
    "successLoan": "ローンが成功しました",
    "Reapply": "再申請",
    "borrow": "ローンに失敗しました",
    "applicantIn": "申請中",
    "repaid": "返済",
    "overdue": "延滞",
    "estirepay": "返済予定額",
    "loanDays": "貸与日数",
    "reAmount": "返済額",
    "repay": "返済モード",
    "entRepay": "返済の確認",
    "foryourmoney": "資金が不足している場合、お金を借りる場所が見つからない場合、または友達からお金を借りるのが恥ずかしい場合は、お問い合わせください。 私たちはいつでもあなたの疑問に答えるために、プロフェッショナルなサービスの全プロセスを持っています. 私たちの目標は、お客様が迅速かつ自信を持って使用できるように、各ローンを透明にすることです。",
    "onlineApplin": "オンラインで申し込む",
    "businessloan": "スタートアップローンの申し込み",
    "selectCountry": "国籍を選択してください",
    "selectPeriod": "期間を選択してください",
    "passPortImg": "ID番号/パスポート番号",
    "uploadId": "証明書の写真/パスポートのアップロード",
    "readAndAgree": "私は読み、同意します",
    "loanAgree": "貸借同意書",
    "submitApplica": "申請書の提出",
    "photoExample": "撮影例",
    "discounted": "割引商品",
    "days": "日",
    "privacyPolicy": "プライバシーポリシー",
    "delivery": "配送と集荷",
    "checkAgreement": "同意書にチェックを入れてください！",
    "businessPhone": "ビジネス用電話機",
    "businessEmail": "社内メール",
    "最多上传9张图片": "最多9枚の写真をアップロードしてください",
    "账号注销": "アカウントの登録解除",
    "确定注销": "登録解除を確認します",
    "您的账号": "あなたのアカウント",
    "为什么要离开": "なぜ離れるのですか",
    "您还有余额,不能注销账号": "残高があります。アカウントを登録解除できません!",
    "请输入注销理由": "登録解除の理由を入力してください",
    "您确认要注销吗?": "あなたは登録解除を確認しますか？",
    "我再考虑下": "もう一度考えてみます",
    "同意注销": "同意します",
    "注销成功": "登録解除に成功しました",
    "暂无店铺": "店舗がありません",
    "App下载(买家端)": "アプリのダウンロード（買い手）",
    "App下载(卖家端)": "アプリのダウンロード（売り手）",
    "请选择": "選択してください",
    "绑定成功": "バインドに成功しました",
    "加值": "加算",
    "平台人工发起退款": "プラットフォーム人工発起返金",
    "银行卡": "銀行カード",
    "联系商家": "商人に連絡する",
    "提领": "引き出し",
    "最多包含10位小数": "最大10桁の小数を含める",
    "企业电话": "企業電話",
    "职业机会": "職場の機会",
    "提款地址绑定": "引き出しアドレスのバインド",
    "仅能绑定一个收款地址!": "受け取りアドレスは1つだけバインドできます！",
    "长时间未付款，系统自动取消订单": "長時間支払われないと、システムは注文を自動的にキャンセルします",
    "加密货币": "暗号通貨",
    "银行卡": "銀行カード",
    '参数缺失': "パラメータが不足しています",
    '充值数量必填': "チャージ数量は必須です",
    "充值币种": "チャージ通貨",
    "充值金额": "チャージ金額",
    "充值金额不得小于": "チャージ金額は以下にすることはできません",
    "充值金额不得大于": "チャージ金額は以下にすることはできません",
    "请先选择币种": "まず通貨を選択してください",
    "开户行": "開設銀行",
    "请输入开户行名称": "開設銀行名を入力してください",
    "银行卡号": "銀行カード番号",
    "请输入银行卡号": "銀行カード番号を入力してください",
    "点击去支付": "クリックして支払いに行く",
    "企业证明": "企業証明",
    "当前余额": "現在の残高",
    "备注": "備考",
    footTipTikTok:'CoveBuy モール ©️2024 著作権',
    TikTokFoot:'CoveBuy は、CoveBuy とアジア最大の卸売商社Alibabaが協力して設立したグローバルショートビデオソーシャルプラットフォームです。 これはグローバルな電子商取引プラットフォームであり、カナダのトロント、ロサンゼルス、日本の千葉にある世界 3 か所に自社運営のスマート ウェアハウスを持っています。 アプリ内で販売されている商品には、日本、韓国、中国などアジア各国の人気商品が含まれています。 現在、その総数は50,000件を超え、急速に成長を続けています。',
    "cancelInfo":"警告します！ アカウントをキャンセルする際は十分にご確認ください.アカウントを使用しなくなった場合は、[キャンセルに同意する]をクリックしてください.キャンセル後、数日以内に登録できない場合があります。",
    "betaBannerText": "ウェブサイトはパブリックテスト中です。ご注文はお控えください"
}